import { useState } from "react";
import ScheduleDialog from "./shedule_order";

function CreateServiceCard() {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const services = [
    {
      title: "Wash And Fold",
      description: "Get your clothes cleaned and delivered in just 24 hours!",
      image: "wash_and_fold.jpeg",
    },
    {
      title: "Wash And Iron",
      description: "Wash and iron for formal and casual wear, ready in 72 hours.",
      image: "wash_and_iron.jpeg",
    },
    {
      title: "Starch",
      description: "Starch and iron for crisp and long-lasting results.",
      image: "starch.webp",
    },
    {
      title: "Steam Press",
      description: "Remove wrinkles completely with our steam press service.",
      image: "steam_iron.jpeg",
    },
    {
      title: "Polish",
      description: "Achieve a brilliant shine with our polishing service for all your garments.",
      image: "polishing.webp",
    },
    {
      title: "Shoe Cleaning",
      description: "Enjoy a spotless finish and extended shoe life with our cleaning service",
      image: "shoe_cleaning.jpeg",
    }
  ];

  return (
    <section className="relative w-full px-4 py-20 md:py-28">
      {/* Themed Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1218] via-[#111827] to-[#1f2937]" />
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff'%3E%3Ccircle cx='1' cy='1' r='1'/%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />

      <div className="relative max-w-7xl mx-auto">
        {/* Heading + Intro */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
            Experience the Future of Laundry Services
          </h2>
          <p className="text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
            No more hassle or outdated methods—our advanced, smart technology ensures your clothes are
            treated with precision. At Muftycare, we take special care of each fabric, providing a gentle
            yet thorough cleaning experience.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-black/50 to-black/30 backdrop-blur-sm border border-white/10 hover:border-orange-500/40 rounded-3xl overflow-hidden transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-2xl hover:shadow-orange-500/10"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Content */}
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-bold text-white text-center group-hover:text-orange-400 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-400 text-center text-sm leading-relaxed">
                  {service.description}
                </p>

                {/* Button */}
                <div className="flex justify-center pt-2">
                  <button
                    onClick={handleOpenDialog}
                    className="px-6 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-black font-bold text-sm rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-orange-500/25 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-orange-500/50"
                  >
                    Book Now
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dialog */}
        <ScheduleDialog open={openDialog} handleClose={handleCloseDialog} />
      </div>
    </section>
  );
}

export default CreateServiceCard;
